<template>
  <div class="w-full flex flex-col justify-center items-center gap-10">
    <Wrapper class="max-w-2xl">
      <h2 class="text-2xl text-left text-blue-dark">
        <b>{{ procedureTitle }}</b>
      </h2>
      <p class="mt-8 mb-2 text-left text-xs text-gray-400">
        Complete los campos solicitados y la información detallada.
      </p>
      <ComplaintEmisorForm
        class="w-full"
        @complaintSelected="handleComplaintSelected"
        :checkPersonalData="checkPersonalData"
        :checkSensitiveData="checkSensitiveData"
      />
    </Wrapper>
    <div
      class="w-11/12 max-w-2xl"
      v-if="is_complaint_selected"
      aria-live="polite"
    >
      <AccordionList class="accordion-list" :items="accordionList" />
    </div>
    <a-modal
      v-model="modalInfoVisible"
      centered
      :footer="null"
      :closable="false"
      @ok="() => (modalInfoVisible = false)"
    >
      <h1 slot="title" class="mb-0 mt-0 pt-8 text-xl text-left text-blue">
        <b>Tratamiento de datos</b>
      </h1>
      <a-timeline>
        <a-timeline-item>
          <hr class="my-4" />
          <p class="text-justify italic">
            De conformidad con lo dispuesto en la Ley 1581 de 2012, el Decreto
            1377 de 2013 y el Decreto 1074 de 2015, autorizo a la
            Superintendencia Financiera de Colombia (SFC) a realizar el
            tratamiento de los datos personales y/o sensibles necesario para el
            ejercicio de sus facultades, de conformidad con lo establecido en la
            Política de Tratamiento de datos de la SFC disponible en el
            siguiente
            <a
              class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600"
              target="_blank"
              rel="noopener"
              href="https://www.superfinanciera.gov.co/publicaciones/10106783/nuestra-entidadacerca-de-la-sfcpoliticas-de-la-entidadpoliticas-web-10106783/"
              >link</a
            >. El texto completo de la autorización se encuentra disponible en
            el siguiente
            <a
              aria-label="Enlace para descargar la autorización de tratamiento de datos personales"
              href="https://www.superfinanciera.gov.co/loader.php?lServicio=Tools2&lTipo=descargas&lFuncion=descargar&idFile=1070896"
              class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600"
              >link</a
            >.
          </p>

          <form
            @submit.prevent="authorizePersonalDataProcessing"
            class="w-full px-0 py-0"
          >
            <div class="w-full flex justify-center">
              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-center w-full">
                  <BaseRadio
                    class="w-full"
                    ref="personalData"
                    name="personalData"
                    id="personalData"
                    label="¿Autorizo el tratamiento de datos personales?"
                    :radioOptions="optionsYN"
                    v-model="checkPersonalData"
                    :required="true"
                  />
                </div>
                <br />
                <div class="flex justify-center">
                  <BaseRadio
                    ref="sensitiveData"
                    name="sensitiveData"
                    id="sensitiveData"
                    label="¿Autorizo el tratamiento de datos sensibles?"
                    :radioOptions="optionsYN"
                    v-model="checkSensitiveData"
                    :required="true"
                  />
                </div>
              </div>
            </div>
            <br />

            <p
              v-if="feedback"
              class="text-xs text-center text-red-500"
              aria-live="polite"
            >
              {{ feedback }}
            </p>

            <div class="flex justify-center mt-3 gap-4">
              <BaseButton
                type="submit"
                id="sendComplaint"
                label="ACEPTAR"
                class="w-1/3"
              />
              <a-button
                class="w-1/3"
                type="danger"
                shape="round"
                :block="true"
                ghost
                @click="onCancelModal"
              >
                CANCELAR
              </a-button>
            </div>
          </form>
        </a-timeline-item>
      </a-timeline>
    </a-modal>
  </div>
</template>

<script>
import ComplaintEmisorForm from "@/components/Customer/Complaint/ComplaintEmisorForm";
export default {
  components: {
    ComplaintEmisorForm,
  },
  data() {
    return {
      procedureTitle: "Presentar una queja contra un emisor de valores",
      modalInfoVisible: true,
      is_complaint_selected: false,
      accordionList: [
        {
          title: "Una vez presentada la queja, ¿qué hace la SFC?",
          body: [
            "La Superintendencia Financiera de Colombia revisará la queja y le dará traslado al emisor de valores para que dé respuesta. Luego, verificará si la inconformidad fue atendida de manera adecuada y, de no ser así, podrá solicitar acciones adicionales.",
            "Si la queja no es de competencia de esta superintendencia, esta será remitida a la autoridad correspondiente, conforme al artículo 21 del Código de Procedimiento Administrativo y de lo Contencioso Administrativo.",
          ],
        },
        {
          title:
            "¿Qué notificaciones recibirá el inversionista por parte de la SFC?",
          body: "Una vez registrada la queja, aparecerá un número de radicado. Una vez la queja haya sido atendida, recibirá la respuesta emitida por la entidad o dependencia competente encargada de su gestión al correo electrónico registrado.",
        },
      ],
      personalDataAuthorized: false,
      checkSensitiveData: 2,
      checkPersonalData: 2,
      optionsYN: [
        { id: 1, name: "Sí" },
        { id: 2, name: "No" },
      ],
      feedback: null,
      procedureType: "queja",
    };
  },
  created() {
    if (this.$route.query.tipo) {
      const tipo = this.$route.query.tipo;
      switch (tipo) {
        case "conciliacion":
          this.procedureTitle = "Presentar una conciliación extrajudicial";
          this.procedureType = "conciliacion";
          break;
        case "demanda":
          this.procedureTitle = "Presentar una demanda";
          this.procedureType = "demanda";
          break;
        default:
          break;
      }
    }
  },
  methods: {
    showToast(result = "info", msg) {
      this.$notification[result]({
        message: "Resultado",
        description: msg,
        onClick: () => {},
      });
    },
    handleComplaintSelected(newValue) {
      this.is_complaint_selected = newValue;
    },
    authorizePersonalDataProcessing() {
      if (this.checkPersonalData != 1) {
        // this.showToast("error","Debes aceptar el tratamiento de datos personales antes de continuar")
        this.feedback =
          "Debes aceptar el tratamiento de datos personales antes de continuar";
      } else {
        this.personalDataAuthorized = true;
        this.modalInfoVisible = false;
      }
    },
    onCancelModal() {
      this.$router.push("/").catch(() => {});
    },
  },
  watch: {
    modalInfoVisible(newValue) {
      if (!newValue && !this.personalDataAuthorized) {
        this.showToast(
          "error",
          "Debes aceptar el tratamiento de datos personales antes de continuar",
        );
        this.modalInfoVisible = true;
      }
    },
    checkPersonalData(newValue) {
      if (newValue != 1) {
        this.feedback =
          "Debes aceptar el tratamiento de datos personales antes de continuar";
      } else {
        this.feedback = "";
      }
      // else if(this.checkSensitiveData == null){
      //   this.showToast("info","Por favor selecciona si deseas autorizar el tratamiento de datos sensibles")

      // }
    },
  },
};
</script>
<style>
.ant-modal-header {
  border-bottom: none;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
